const GroupRowInnerRenderer = (params) => {
    let donationDate = params.node.aggData.donorDonationDateTime;
    let tempDiv = document.createElement('div');

    if (donationDate != '') {
        tempDiv.innerHTML = `<div style='width: 100%; display: flex; justify-content: space-between;'>
                <div>${params.value}&nbsp;(${params.node.allChildrenCount})</div>
                <div>donated: ${donationDate}</div>
            </div>`;
    } else {
        tempDiv.innerHTML = `<div>${params.value}</div>`;
    }

    return tempDiv;
}

export default GroupRowInnerRenderer;